import {
  ALIGNMENTS,
  BackgroundPosition,
  FallthroughType,
  FontSizeKey,
  FontStack,
  FontStyle,
  IAASettingsFields,
  Item,
  LabelSize,
  Placement,
  PlacementItem,
  SettingsIAE,
  Size,
  SizeItem,
  ViewType,
  ViewTypeItem,
} from 'airship/page/app-experience-settings/types'
import {MenuItem} from 'airship/patterns/Menu'

import {MenuItemId} from './utils'

export const VIEWTYPE_ITEMS: ViewTypeItem[] = [
  {id: ViewType.BANNER, label: 'Banner'},
  {id: ViewType.MODAL, label: 'Modal'},
  {id: ViewType.FULLSCREEN, label: 'Fullscreen'},
  {id: ViewType.HTML, label: 'HTML'},
]

export const PLACEMENT_ITEMS: PlacementItem[] = [
  {id: Placement.TOP, label: 'Top'},
  {id: Placement.BOTTOM, label: 'Bottom'},
]

export const SIZE_ITEMS: SizeItem[] = [
  {id: Size.LARGE, label: 'Large'},
  {id: Size.MEDIUM, label: 'Medium'},
  {id: Size.SMALL, label: 'Small'},
]

export const ALIGNMENTS_ITEMS = [
  {display: 'Left', value: 'left'},
  {display: 'Center', value: 'center'},
  {display: 'Right', value: 'right'},
]

export const FONT_STYLE: FontStyle = {
  italic: false,
  bold: false,
  underlined: false,
}

export const DEFAULT_FONT_STACKS: Item[] = [
  {id: FallthroughType.SERIF, label: 'Serif: Default'},
  {id: FallthroughType.SANS_SERIF, label: 'Sans-serif: Default'},
]

export const DEFAULT_COLOR_IDS = {
  PRIMARY: 'eeb7224e-cca4-4b4f-9109-96e7dd2e3b87',
  PRIMARY_VARIANT: 'd92c2f04-1580-4d04-8429-7fa7a8feefb6',
  SECONDARY: '5f246339-d509-4365-8595-43342e49ef11',
  SECONDARY_VARIANT: '75b2b1d1-4cfd-4c54-9263-9216967871c6',
  TERTIARY: '245aab00-c9ca-47bd-8201-13ea3e784dfc',
  BACKGROUND: '04f3aae7-5125-4c9c-bdab-4d1251f98b80',
  SURFACE: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
}

export const COMMON_PROPS_BUTTON = {
  label_size: Size.MEDIUM,
  border_radius: 0,
  font_family: 'sans-serif',
}

export const FIRST_BUTTON = {
  ...COMMON_PROPS_BUTTON,
  text_color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
  background_color: 'eeb7224e-cca4-4b4f-9109-96e7dd2e3b87',
  border_color: 'eeb7224e-cca4-4b4f-9109-96e7dd2e3b87',
}

export const SECOND_BUTTON = {
  ...COMMON_PROPS_BUTTON,
  text_color: '04f3aae7-5125-4c9c-bdab-4d1251f98b80',
  background_color: 'd92c2f04-1580-4d04-8429-7fa7a8feefb6',
  border_color: 'd92c2f04-1580-4d04-8429-7fa7a8feefb6',
}

export const THIRD_BUTTON = {
  ...COMMON_PROPS_BUTTON,
  text_color: '04f3aae7-5125-4c9c-bdab-4d1251f98b80',
  background_color: '5f246339-d509-4365-8595-43342e49ef11',
  border_color: '5f246339-d509-4365-8595-43342e49ef11',
}

export const FOURTH_BUTTON = {
  ...COMMON_PROPS_BUTTON,
  text_color: '04f3aae7-5125-4c9c-bdab-4d1251f98b80',
  background_color: '75b2b1d1-4cfd-4c54-9263-9216967871c6',
  border_color: '75b2b1d1-4cfd-4c54-9263-9216967871c6',
}

export const FIFTH_BUTTON = {
  ...COMMON_PROPS_BUTTON,
  text_color: '04f3aae7-5125-4c9c-bdab-4d1251f98b80',
  background_color: '245aab00-c9ca-47bd-8201-13ea3e784dfc',
  border_color: '245aab00-c9ca-47bd-8201-13ea3e784dfc',
}

export const DEFAULT_BACKGROUND_FIELDS = {
  background_color: '04f3aae7-5125-4c9c-bdab-4d1251f98b80',
  dismiss_action_color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
  placement: Placement.BOTTOM,
  border_radius: 0,
}

export const DEFAULT_FIELDS = {
  text_color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
  size: 'medium',
  alignment: ALIGNMENTS[0],
  style: FONT_STYLE,
  font_family: 'sans-serif',
}

export const DEFAULT_HEADING_FIELDS = {
  heading_text_color: DEFAULT_FIELDS.text_color,
  heading_size: DEFAULT_FIELDS.size,
  heading_alignment: DEFAULT_FIELDS.alignment,
  heading_style: DEFAULT_FIELDS.style,
  heading_font_family: DEFAULT_FIELDS.font_family,
}
export const DEFAULT_BODY_FIELDS = {
  body_text_color: DEFAULT_FIELDS.text_color,
  body_size: DEFAULT_FIELDS.size,
  body_alignment: DEFAULT_FIELDS.alignment,
  body_style: DEFAULT_FIELDS.style,
  body_font_family: DEFAULT_FIELDS.font_family,
}
export const DEFAULT_FOOTER_FIELDS = {
  footer_text_color: DEFAULT_FIELDS.text_color,
  footer_size: DEFAULT_FIELDS.size,
  footer_alignment: DEFAULT_FIELDS.alignment,
  footer_style: DEFAULT_FIELDS.style,
  footer_font_family: DEFAULT_FIELDS.font_family,
}

export const DEFAULT_BUTTONS_BANNER_MODAL = {
  buttons: [FIRST_BUTTON, SECOND_BUTTON],
}

export const DEFAULT_BUTTONS_FULLSCREEN = {
  buttons: [
    FIRST_BUTTON,
    SECOND_BUTTON,
    THIRD_BUTTON,
    FOURTH_BUTTON,
    FIFTH_BUTTON,
  ],
}

export const DEFAULT_BANNER = {
  ...DEFAULT_BACKGROUND_FIELDS,
  ...DEFAULT_HEADING_FIELDS,
  ...DEFAULT_BODY_FIELDS,
  ...DEFAULT_BUTTONS_BANNER_MODAL,
  extra_buttons: FIRST_BUTTON,
  button_layout: 'stacked',
}

export const DEFAULT_MODAL = {
  ...DEFAULT_BACKGROUND_FIELDS,
  ...DEFAULT_HEADING_FIELDS,
  ...DEFAULT_BODY_FIELDS,
  ...DEFAULT_FOOTER_FIELDS,
  ...DEFAULT_BUTTONS_BANNER_MODAL,
  extra_buttons: FIRST_BUTTON,
  button_layout: 'stacked',
}

export const DEFAULT_FULLSCREEN = {
  ...DEFAULT_BACKGROUND_FIELDS,
  ...DEFAULT_HEADING_FIELDS,
  ...DEFAULT_BODY_FIELDS,
  ...DEFAULT_FOOTER_FIELDS,
  ...DEFAULT_BUTTONS_FULLSCREEN,
  extra_buttons: FIRST_BUTTON,
  button_layout: 'stacked',
}

export const DEFAULT_HTML = {
  background_color: DEFAULT_BACKGROUND_FIELDS.background_color,
  dismiss_action_color: DEFAULT_BACKGROUND_FIELDS.dismiss_action_color,
  border_radius: DEFAULT_BACKGROUND_FIELDS.border_radius,
}

export const DEFAULT_FONT_SIZES = {
  heading: {
    small: 18,
    medium: 20,
    large: 22,
  },
  body: {
    small: 14,
    medium: 16,
    large: 18,
  },
  footer: {
    small: 18,
    medium: 20,
    large: 22,
  },
  button: {
    small: 14,
    medium: 16,
    large: 18,
  },
}

export const DEFAULT_IAA_SETTINGS_FIELDS: IAASettingsFields = {
  banner: DEFAULT_BANNER,
  fullscreen: DEFAULT_FULLSCREEN,
  modal: DEFAULT_MODAL,
  html: DEFAULT_HTML,
  font_sizes: DEFAULT_FONT_SIZES,
}

export const DEFAULT_IAX_SETTINGS_FIELDS: SettingsIAE = {
  typographies: [
    {
      id: '134c9029-f432-4e36-8458-bf35425f1f60',
      name: 'Headline Large',
      font: FallthroughType.SANS_SERIF,
      size: 24,
      alignment: 'left',
      style: {
        bold: true,
        italic: false,
        underlined: false,
      },
      color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
    },
    {
      id: 'a99b58bf-d996-4ac5-9cb3-f9cda4d1dafd',
      name: 'Headline small',
      font: FallthroughType.SANS_SERIF,
      size: 22,
      alignment: 'left',
      style: {
        bold: false,
        italic: false,
        underlined: false,
      },
      color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
    },
    {
      id: 'ffa92cef-8dd0-4ca3-9cb9-',
      name: 'Title Large',
      font: FallthroughType.SANS_SERIF,
      size: 20,
      alignment: 'left',
      style: {
        bold: true,
        italic: false,
        underlined: false,
      },
      color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
    },
    {
      id: '8efd5232-c0b0-453f-84f8-87685e52957b',
      name: 'Title small',
      font: FallthroughType.SANS_SERIF,
      size: 18,
      alignment: 'left',
      style: {
        bold: false,
        italic: false,
        underlined: false,
      },
      color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
    },
    {
      id: '52970bc4-6fa0-49e4-90b1-3c206a0fc0b8',
      name: 'Body Large',
      font: FallthroughType.SANS_SERIF,
      size: 16,
      alignment: 'left',
      style: {
        bold: true,
        italic: false,
        underlined: false,
      },
      color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
    },
    {
      id: '031ac3a1-5c3d-4fe0-b6ce-962c2fa02f28',
      name: 'Body small',
      font: FallthroughType.SANS_SERIF,
      size: 14,
      alignment: 'left',
      style: {
        bold: false,
        italic: false,
        underlined: false,
      },
      color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
    },
    {
      id: 'd0b0674a-52f4-4249-8730-ac2e86732c2e',
      name: 'Button',
      font: FallthroughType.SANS_SERIF,
      size: 16,
      alignment: 'left',
      style: {
        bold: false,
        italic: false,
        underlined: false,
      },
      color: '04f3aae7-5125-4c9c-bdab-4d1251f98b80',
    },
    {
      id: '507e24b2-c430-4615-8979-344b3eb01d7c',
      name: 'Text Button',
      font: FallthroughType.SANS_SERIF,
      size: 16,
      alignment: 'left',
      style: {
        bold: false,
        italic: false,
        underlined: false,
      },
      color: 'eeb7224e-cca4-4b4f-9109-96e7dd2e3b87',
    },
  ],
  backgrounds: [
    {
      id: '9d825580-e4b4-42f4-9e8f-8468b906a1f6',
      name: 'Fullscreen',
      width: {
        default: {
          value: 100,
          unit: '%',
        },
        max: {
          value: 100,
          unit: '%',
        },
        min: {
          value: 100,
          unit: '%',
        },
      },
      height: {
        default: {
          value: 100,
          unit: '%',
        },
        max: {
          value: 100,
          unit: '%',
        },
        min: {
          value: 100,
          unit: '%',
        },
      },
      position: BackgroundPosition.Top,
      borderRadius: 0,
    },
    {
      id: '177b5db1-af6e-4424-a1e9-fc26b4a9153f',
      name: 'Modal',
      width: {
        default: {
          value: 80,
          unit: '%',
        },
        max: {
          value: 80,
          unit: '%',
        },
        min: {
          value: 80,
          unit: '%',
        },
      },
      height: {
        default: {
          value: 75,
          unit: '%',
        },
        max: {
          value: 75,
          unit: '%',
        },
        min: {
          value: 75,
          unit: '%',
        },
      },
      position: BackgroundPosition.Top,
      borderRadius: 0,
    },
  ],
  buttons: [
    {
      id: '18335c3b-95cf-4946-b57d-162448fa5f7a',
      name: 'Filled',
      typography: 'd0b0674a-52f4-4249-8730-ac2e86732c2e',
      color: 'eeb7224e-cca4-4b4f-9109-96e7dd2e3b87',
      border: {
        size: 0,
        radius: 3,
        color: 'eeb7224e-cca4-4b4f-9109-96e7dd2e3b87',
      },
    },
    {
      id: '5201435d-044f-4ac5-90e5-1137560b40d6',
      name: 'Outlined',
      typography: '507e24b2-c430-4615-8979-344b3eb01d7c',
      color: '5fea9c2c-99b9-4d4a-b5b0-f3c1edf032cb',
      border: {
        size: 1,
        radius: 3,
        color: 'eeb7224e-cca4-4b4f-9109-96e7dd2e3b87',
      },
    },
    {
      id: 'bc506ff4-9da3-44fe-8c31-16ed3cb53632',
      name: 'Button text',
      typography: '507e24b2-c430-4615-8979-344b3eb01d7c',
      color: '5fea9c2c-99b9-4d4a-b5b0-f3c1edf032cb',
      border: {
        size: 0,
        radius: 0,
        color: '5fea9c2c-99b9-4d4a-b5b0-f3c1edf032cb',
      },
    },
  ],
  dismiss: {
    color: 'e5cf7b7c-1d4a-417f-bdef-0234eeff9f34',
  },
  indicators: {
    active: {color: '7a2d56b9-8a07-4d85-9d58-851690a4a234'},
    inactive: {color: '3b1a9f22-622c-41a8-a77a-c10002ad6b2f'},
  },
  background: {
    color: DEFAULT_COLOR_IDS.BACKGROUND,
  },
}

export const MAX_NUMBER_COLORS = 40
export const MAX_NUMBER_WINDOWS = 25
export const MAX_NUMBER_TYPO = 25
export const MAX_NUMBER_BUTTONS = 25

export const DEFAULT_MISS_BEHAVIOR = 'penalize'

export const DEFAULT_FONT_SANS_SERIF: FontStack = {
  fallthrough: FallthroughType.SANS_SERIF,
  fonts: [],
  name: '',
}

export const DEFAULT_FONT_SERIF: FontStack = {
  fallthrough: FallthroughType.SERIF,
  fonts: [],
  name: '',
}

export const SIZE_SECTION_LABELS = [
  FontSizeKey.HEADING,
  FontSizeKey.BODY,
  FontSizeKey.FOOTER,
  FontSizeKey.BUTTON,
]

export const SIZE_LABELS = [LabelSize.SMALL, LabelSize.MEDIUM, LabelSize.LARGE]

export const FONT_STACK_EDITOR_CONFIGS: {
  title: string
  fallthrough: FallthroughType
}[] = [
  {
    title: 'Sans-Serif Fonts',
    fallthrough: FallthroughType.SANS_SERIF,
  },

  {
    title: 'Serif Fonts',
    fallthrough: FallthroughType.SERIF,
  },
]

export const MENU_ITEM_DEFAULT: MenuItem<string> = {
  id: MenuItemId.GENERAL,
  label: 'General',
}
export const MENU_ITEM_IAA: MenuItem<string> = {
  id: MenuItemId.IAA,
  label: 'In-App Automation',
}

export const MENU_ITEM_AXP: MenuItem<string> = {
  id: MenuItemId.AXP,
  label: 'Scenes',
}

export const COLOR_HEXA_REGEX_6 = /^#[A-Fa-f0-9]{6}$/
export const COLOR_HEXA_REGEX_8 = /^#[a-fA-F0-9]{6}([a-fA-F0-9]{2})?$/
